import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { MOD_ORDER, MODS } from './shell/modules';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { ConfigErrorScreen, ForceChangeScreen, LoadingScreen, LoginScreen, SetupScreen } from './auth/AuthScreens';
import { isConfigured } from './lib/config';
import { Shell } from './shell/Shell';
// Mỗi phân hệ tải riêng khi mở lần đầu, để trang đầu nhẹ.
const UsersPage = lazy(() => import('./modules/users/UsersPage').then(m => ({ default: m.UsersPage })));
const DocsPage = lazy(() => import('./modules/docs/DocsPage').then(m => ({ default: m.DocsPage })));
const CashPage = lazy(() => import('./modules/cash/CashPage').then(m => ({ default: m.CashPage })));
const OrgPage = lazy(() => import('./modules/org/OrgPage').then(m => ({ default: m.OrgPage })));
const LaborPage = lazy(() => import('./modules/labor/LaborPage').then(m => ({ default: m.LaborPage })));
const TasksPage = lazy(() => import('./modules/tasks/TasksPage').then(m => ({ default: m.TasksPage })));
const CalPage = lazy(() => import('./modules/cal/CalPage').then(m => ({ default: m.CalPage })));
const VbPage = lazy(() => import('./modules/vb/VbPage').then(m => ({ default: m.VbPage })));


function lastModule(): string {
  try { return localStorage.getItem('ct_mod') || ''; } catch { return ''; }
}

function Home() {
  const { can } = useAuth();
  const last = lastModule();
  const target = (MODS[last] && can(last) ? last : MOD_ORDER.find(can)) || 'tasks';
  return <Navigate to={'/' + target} replace />;
}

/** Chỉ cho vào phân hệ được cấp quyền; ghi nhớ phân hệ cuối cùng đã mở. */
function Module({ mod, children }: { mod: string; children: React.ReactNode }) {
  const { can } = useAuth();
  if (!can(mod)) return <Navigate to="/" replace />;
  try { localStorage.setItem('ct_mod', mod); } catch { /* bỏ qua */ }
  return <Suspense fallback={<LoadingScreen />}>{children}</Suspense>;
}

function Gate() {
  const { state } = useAuth();
  switch (state.phase) {
    case 'loading': return <LoadingScreen />;
    case 'setup': return <SetupScreen />;
    case 'anon': return <LoginScreen message={state.message} />;
    case 'must-change': return <ForceChangeScreen />;
    case 'ready':
      return (
        <Routes>
          <Route element={<Shell />}>
            <Route index element={<Home />} />
            <Route path="vb/*" element={<Module mod="vb"><VbPage /></Module>} />
            <Route path="cal/*" element={<Module mod="cal"><CalPage /></Module>} />
            <Route path="tasks/*" element={<Module mod="tasks"><TasksPage /></Module>} />
            <Route path="labor/:tab?" element={<Module mod="labor"><LaborPage /></Module>} />
            <Route path="org/:tab?" element={<Module mod="org"><OrgPage /></Module>} />
            <Route path="cash/:tab?" element={<Module mod="cash"><CashPage /></Module>} />
            <Route path="docs/:tab?" element={<Module mod="docs"><DocsPage /></Module>} />
            <Route path="users/*" element={<Module mod="users"><UsersPage /></Module>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      );
  }
}

export default function App() {
  if (!isConfigured()) return <ConfigErrorScreen />;
  return <AuthProvider><Gate /></AuthProvider>;
}
